import React, {useMemo, useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';

//store functions
import {setActiveLobbyTab, openModal, setOtpPopupData} from '../cellcomAbroadBlockSlice';
import EpiContext from '@episerver/spa-core/Spa';
import {TabContent, Nav, Row, Col} from 'reactstrap';
import TabButtonComponent from './TabButtonComponent';
import TabViewIfSelectedPackageExistsComponent from './TabViewIfSelectedPackageExistsComponent';
import TabContentComponent from './TabContentComponent';
import SearchParametersHolderComponent from '../SearchAbroadPackage/SearchParametersHolderComponent';
import PackageExistsComponent from '../PackageExists/PackageExistsComponent';
import OtpVerificationComponent from '../OtpVerification/OtpVerificationComponent';
import {
  lobbyTabsEnum,
  customerTypeEnum,
  popupReasonEnum,
  otpValidationPopupContent,
  lobbyTabsButtonsToSelfCare,
  lobbyTabsButtons,
} from '../cellcomAbroadVariables';
import {getReportParams, report} from '../../../../middleware/report';
import {getItem} from '../../../../utilities/localStorageUtils';
import {getSubscriberDetails, setSelectedSubscriber, setRetainSubscriberOnLoad} from '../../../Page/SelfCarePage/SelfCareSlice';
import {otpOrigin, originProcess} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const LobbyTabsHolderComponent = (props) => {
  const dispatch = useDispatch();

  const packagesWrapperStyle =
    isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution
      ? {
          marginBottom: props.data.epiStyleInitializationData.spacingBetweenSearchAndResultDataMobile,
        }
      : {
          marginBottom: props.data.epiStyleInitializationData.spacingBetweenSearchAndResultDataDesktop,
        };
  let currentComponent = useMemo(() => {
    return getCurrentComponent();
  }, [props.data.activeLobbyTab, props.authentication]);

  function getCurrentComponent() {
    let component = null;
    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE: {
        component = <SearchParametersHolderComponent context={props.context} validateCustomerType={props.validateCustomerType} />;
        break;
      }
      case lobbyTabsEnum.PACKAGEEXISTS: {
        component =
          props.authentication?.loginData?.isFullAuthenticated ||
          props.authentication?.loginData?.isOtpAuthenticated ||
          props.authentication?.loginData?.isOtpExtendedAuthenticated ||
          props.authentication?.loginData?.isSilentOtpAuthenticated ? (
            <PackageExistsComponent
              context={props.context}
              epiStyleInitializationData={props.data.epiStyleInitializationData}
              isShowDataUsage={props.data.isShowDataUsage}
              validateExistedPackages={props.validateExistedPackages}
            />
          ) : (
            <OtpVerificationComponent
              otpOrigin={otpOrigin.ABROAD}
              originProcess={originProcess.LOBBY}
              validateExistedPackages={props.validateExistedPackages}
            />
          );
        break;
      }
      case lobbyTabsEnum.BUSINESSACCOUNT: {
        component =
          props.authentication?.loginData?.isFullAuthenticated ||
          props.authentication?.loginData?.isOtpAuthenticated ||
          props.authentication?.loginData?.isOtpExtendedAuthenticated ||
          props.authentication?.loginData?.isSilentOtpAuthenticated ? (
            <SearchParametersHolderComponent isBusiness context={props.context} validateCustomerType={props.validateCustomerType} />
          ) : (
            <OtpVerificationComponent otpOrigin={otpOrigin.ABROAD} originProcess={originProcess.LOBBY} />
          );
        break;
      }
      case lobbyTabsEnum.BUSINESSINDIVIDUAL: {
        component = <SearchParametersHolderComponent isBusiness context={props.context} />;
        break;
      }
      case lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL: {
        component = (
          <PackageExistsComponent
            context={props.context}
            epiStyleInitializationData={() => props.data.epiStyleInitializationData()}
            isShowDataUsage={props.data.isShowDataUsage}
          />
        );
        break;
      }
      case lobbyTabsEnum.SELFCAREABROAD: {
        const handleSelectedSubscriber = async () => {
          await dispatch(setRetainSubscriberOnLoad(true));
          await dispatch(getSubscriberDetails(props.data.otpData.otpPhone));
        };
        handleSelectedSubscriber();
        if (props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS) {
          props.setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
        } else {
          props.setActiveLobbyTab(lobbyTabsEnum.PRIVATE);
        }
        props.context.navigateTo(props.linkForAbroadSelfCare.value.url);
        break;
      }
    }
    return component;
  }

  const toggle = (tab) => {
    if (tab.id == lobbyTabsEnum.BUSINESSACCOUNT) {
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Cellcom Abroad';
      reportParams.channel = props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT ? 'WebsiteBusiness' : 'WebsitePrivate';
      reportParams.actionType = 'User clicked business';
      reportParams.status = 'Ongoing';
      reportParams.messageText = 'User clicked business';
      reportParams.param1 = 'WEBSITE';
      if (props.data.isJETAuthentication) {
        reportParams.param1 = 'JET';
      }
      reportParams.param3 = props.data.otpData?.validatedCostumerData?.isSeparatedSale ? 'מכר בהפרדה' : '';
      reportParams.subscriber = props.data.otpData?.otpPhone ? props.data.otpData?.otpPhone : '';
      report(reportParams);
    }

    if (props.data.activeLobbyTab !== tab.id) {
      if (
        (props.data.otpData.isOTPValidated || props.data.otpData.isOtpValidatedPackageTab) &&
        props.data.otpData.otpPhone == props.data.otpData.validatedPhoneNumber
      ) {
        let popup;
        if (tab.id == lobbyTabsEnum.BUSINESSACCOUNT && props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.PRIVATE) {
          popup = otpValidationPopupContent.isPrivateAccountInfo;
        } else if (tab.id == lobbyTabsEnum.PRIVATE && props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS) {
          popup = otpValidationPopupContent.isBusinessAccountInfo;
        }

        if (popup) {
          props.setOtpPopupData(popup);
          props.openModal(popupReasonEnum.OTP_RESULT);
          return false;
        }
      }
      props.setActiveLobbyTab(tab.id);
      getCustomerOnTabToggle(tab.id);
    }
  };

  function getCustomerOnTabToggle(tabName) {
    if (!props.data.epiStyleInitializationData.businessIndividualLobby && (props.data.otpData.otpPhone || getItem('abroadOTP', true))) {
      let isAuth =
        props.data.isJETAuthentication ||
        props.authentication?.loginData?.isFullAuthenticated ||
        props.authentication?.loginData?.isOtpAuthenticated ||
        props.authentication?.loginData?.isOtpExtendedAuthenticated ||
        props.authentication?.loginData?.isSilentOtpAuthenticated;
      let lastOtpData = getItem('abroadOTP', true);
      let validatedPhone =
        lastOtpData?.validatedPhone?.trim() != props.data.otpData.otpPhone && !props.data.startedFromTracker
          ? lastOtpData?.validatedPhone?.trim()
          : '';

      if (
        (tabName == lobbyTabsEnum.PRIVATE || tabName == lobbyTabsEnum.BUSINESSACCOUNT) &&
        isAuth &&
        (props.data.otpData.otpPhone != props.data.otpData.validatedPhoneNumber ||
          !props.data.otpData.validatedPhoneNumber ||
          validatedPhone)
      ) {
        let type = tabName == lobbyTabsEnum.PRIVATE ? customerTypeEnum.PRIVATE : customerTypeEnum.BUSINESS;
        let JETConnection = props.data.isJETAuthentication;

        if (props.data.customerAbroadPackages == 'Pending') {
          let phoneNumber = props.data.otpData.otpPhone;
          props.validateCustomerType({JETConnection, phoneNumber, type});
        } else {
          let phoneNumber = validatedPhone;
          props.validateCustomerType({JETConnection, phoneNumber, type});
        }
      } else if (tabName == lobbyTabsEnum.PACKAGEEXISTS && isAuth) {
        if (props.data.otpData.otpPhone) {
          props.validateExistedPackages(validatedPhone);
        }
      }
    } else if (tabName == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL) {
      if (props.data.businessIndividualData.selectedAccountNumber?.trim()) {
        props.validateExistedPackagesBusinessIndividual();
      } else {
        props.changeAccountBusinessIndividual();
      }
    }
  }

  return (
    <div className='lobby-tabs-content' style={packagesWrapperStyle}>
      {!props.data.selectedAbroadPackage ? (
        <Row>
          <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-6'}`}>
            <Nav
              tabs
              className={`${
                isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'justify-content-center' : 'd-inline-flex'
              } w-100 p-0 border-0`}>
              {props.data.lobbyTabsButtons.map((tab, index) => {
                return (
                  <Col className='p-0' key={index}>
                    <TabButtonComponent
                      active={tab.id == props.data.activeLobbyTab}
                      icon={tab.icon}
                      activeIcon={tab.activeIcon}
                      title={tab.title}
                      onClick={() => {
                        toggle(tab);
                      }}
                      isSmallResolution={props.data.isSmallResolution}
                      isPortrait={props.data.isPortrait}
                    />
                  </Col>
                );
              })}
            </Nav>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-5 pl-0'}`}>
            <Nav className='p-0'>
              <Col className='p-0'>
                <TabViewIfSelectedPackageExistsComponent
                  selectedPackage={props.data.selectedAbroadPackage}
                  supportedApps={props.data.getEpiGeneralData.supportedApps}
                  context={props.context}
                  isPortrait={props.data.isPortrait}
                  clearSelectedAbroadPackage={props.clearSelectedAbroadPackage}
                />
              </Col>
            </Nav>
          </Col>
        </Row>
      )}
      <TabContent activeTab={props.data.activeLobbyTab}>
        <TabContentComponent
          tabId={props.data.activeLobbyTab}
          component={currentComponent}
          step2Validated={
            props.data.otpData.step2Validated && !props.data.otpData.isOTPValidated && !props.data.otpData.isOtpValidatedPackageTab
          }
          otpValidated={props.data.otpData.isOTPValidated}
          otpValidatedPackageTab={props.data.otpData.isOtpValidatedPackageTab}
          packageTabLoader={
            (props.data.otpData.isOTPValidated ||
              (props.data.epiStyleInitializationData.businessIndividualLobby && props.data.customerAbroadPackages != 'GeneralError')) &&
            !props.data.otpData.isOtpValidatedPackageTab
          }
          businessIndividualLobby={props.data.epiStyleInitializationData.businessIndividualLobby}
          customerAbroadPackagesRequestCompleted={props.data.customerAbroadPackagesRequestCompleted}
        />
      </TabContent>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  setActiveLobbyTab,
  openModal,
  setOtpPopupData,
};

export default connect(mapStateToProps, mapDispatchToProps)(LobbyTabsHolderComponent);
